import { Box, Typography } from "@mui/material"
import { useUnitStyles } from "./unitStyles"

const BodyUnit = (props: any) => {
    const unit = JSON.parse(props.current)
    const styles = useUnitStyles()

    return (
        <Box sx={styles.containerUnit}>
            {!!unit?.zone ||
                !!unit?.store ||
                !!unit?.class ? (
                <>
                    {!!unit?.store && (
                        <Typography sx={styles.unitContent} className="w-full">
                            {unit?.store ?? 'N/A'}
                        </Typography>
                    )}

                    {!!unit?.zone && (
                        <Typography sx={styles.unitContent} className="w-full">
                            {unit?.zone ?? 'N/A'} - {unit?.class ?? 'N/A'}
                        </Typography>
                    )}

                    {!unit?.zone && (
                        <Typography sx={styles.unitContent} className="w-full">
                            N/A
                        </Typography>
                    )}


                </>
            ) : (
                <Typography sx={styles.user} className="w-full">
                    'N/A'
                </Typography>
            )}
        </Box>
    )
}
export { BodyUnit }